// extracted by mini-css-extract-plugin
export default {"overideSelect":"LabelSelector_overideSelect__NK85P"};